import {Slider} from './Slider';

export class SliderNavigationDynamic {

    private item;

    constructor (private container:JQuery,private slider:JQuery) {
        this.slider.on('slider.change',(ev,data)=>this.onchange(ev,data));
        this.container.on('click',(ev)=>this.onclick(ev));
        this.item=container.find('.slider-navigation-item');
        this.item.remove();
        let pane=slider.find('.slider-pane');
        new ResizeObserver(()=>this.onresize()).observe(pane[0]);
    }

    private getItemsPerPage() {
        let pane=this.slider.find('.slider-pane');
        let item=this.slider.find('.slider-item');
        let panew=pane.width();
        let itemw=item.width();
        assert(panew!==undefined && itemw!==undefined);
        let itemsPerPage=Math.round(panew/itemw);
        return itemsPerPage;
    }

    private onresize() {
        let items=this.slider.find('.slider-item');
        let itemsTotal=items.length;
        let itemsPerPage=this.getItemsPerPage();
        let pageCount=Math.floor(itemsTotal/itemsPerPage);
        let inner=this.container.find('.slider-navigation-container');
        let slider=new Slider(this.slider);
        let activeElement=slider.getElement();
        let activeIndex=activeElement.index();
        let activePage=Math.floor(activeIndex/itemsPerPage);
        inner.empty();
        for (let k=0;k<pageCount;k++) {
            let newItem=this.item.clone();
            newItem.attr('data-index',k);
            if (k==activePage) newItem.addClass('active');
            inner.append(newItem);
        }
    }

    private onclick(ev:JQuery.TriggeredEvent) {
        let item=$(ev.target).closest('.slider-navigation-item');
        if (!item.length) return;
        let idx=item.data('index');
        if (idx===undefined) return;
        let slider=new Slider(this.slider);
        slider.scrollToIndex(idx);
    }

    private onchange(ev:JQuery.TriggeredEvent,data:any) {
        let items=this.container.find('.slider-navigation-item');
        let itemsPerPage=this.getItemsPerPage();
        let currentPage=Math.floor(data.index/itemsPerPage);
        items.removeClass('active');
        items.filter('[data-index="'+currentPage+'"]').addClass('active');
    }

}

export {};